export default "__VITE_ASSET__24ae1fe1__"